import { useCallback } from "react";
const supportedAriaRoles = [
    "link",
    "button",
    "textbox",
    "checkbox",
    "radio",
    "combobox",
    "option",
    "menuitem",
    "menuitemradio",
    "menuitemcheckbox"
];
const supportedHtmlTags = ["A", "BUTTON", "INPUT", "TEXTAREA", "SELECT"];
const isInteractiveRole = (role) => supportedAriaRoles.includes(role);
const isLabel = (e) => e.tagName === "LABEL";
const nonInteractiveLabelableTags = ["METER", "OUTPUT", "PROGRESS"];
const isInteractiveLabeled = (e) => !nonInteractiveLabelableTags.includes(e.tagName);
const isInteractiveElement = (e) => {
    if (e.hasAttribute("role")) {
        return isInteractiveRole(e.getAttribute("role"));
    }
    if (isLabel(e)) {
        const { control } = e;
        return (control !== null &&
            isInteractiveLabeled(control) &&
            !control.disabled &&
            control.type !== "hidden");
    }
    return supportedHtmlTags.includes(e.tagName);
};
export function useClickThrough(ref, handleClickThrough) {
    return useCallback((event) => {
        const isInDomTree = () => ref.current?.contains(event.target);
        const isClickThrough = () => !event.nativeEvent.composedPath().some((el) => el instanceof HTMLElement && isInteractiveElement(el));
        if (!isInDomTree() || !isClickThrough()) {
            return;
        }
        handleClickThrough?.(event);
        // TODO: handle focus restoration to the primary focus target, but don't conflict with external focus mgmt (check activeElement === document.body?)
    }, [handleClickThrough, ref]);
}
